import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LicenseIsuueRoutingModule } from './license-isuue-routing.module';
import { DoctorlicenseComponent } from './doctorlicense/doctorlicense.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BsDatepickerModule, TimepickerModule } from 'ngx-bootstrap';
import { AppMaterialModule } from 'src/app/app-material.module';


@NgModule({
  declarations: [
    DoctorlicenseComponent
  ],
  imports: [
    CommonModule,
    LicenseIsuueRoutingModule,
    CommonModule,
    DataTablesModule,
    FormsModule,
    NgbModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule,
    TimepickerModule.forRoot(),
    AppMaterialModule
  ]
})
export class LicenseIsuueModule { }
